import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import { buildNarrativeFields } from "../fields/narrative";
import type { Narrative } from "../../types";

export function ReadOnlyNarrativeContainer({
  narrative,
}: {
  narrative?: Narrative;
}) {
  return (
    <Box data-testid="read-only-narrative-container">
      <SectionCollapsible label="Narrative">
        <SectionFields
          fields={buildNarrativeFields(narrative)}
          columns={1}
          fieldIdPrefix="read-only-narrative"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyNarrativeContainer;
